import styled from "styled-components";
import Form from "react-bootstrap/Form";
import { Modal } from "components/Modal";

export const ChoosePlanModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 1240px;
    font-family: "Geist", sans-serif;
  }

  .modal-content {
    padding: 0;
    border: none;
    border-radius: 20px;
    padding: 0;
    margin: 0;
  }

  .modal-body {
    padding: 0;
    margin: 0;
  }

  .heading {
    border-bottom: 1px solid #e9eaeb;
    padding: 16px 20px 16px;

    h2 {
      color: #181d27;
      font-size: 14px;
      font-family: "Geist", sans-serif;
      font-weight: 500;
      margin-bottom: 0px;
    }
  }

  .plan-container {
    padding: 20px;

    .plan-toggle {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
      font-size: 14px;
      color: #0a0d12b2;
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 20px;

      .text-save {
        background: #eff5ff;
        border: 1px solid #bdd8ff;
        padding: 2px 8px;
        border-radius: 16px;
        font-size: 12px;
        color: #1841dd;
      }
    }

    .plan-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 1rem;
      width: 100%;
      justify-items: center;
      align-items: stretch;
    }
  }
`;

export const BillingSwitch = styled(Form.Check)`
  .form-check-input {
    width: 42px;
    height: 22px;
    cursor: pointer;
    box-shadow: none;
    transition: background-color 0.25s ease, border-color 0.25s ease;
    background-color: ${({ checked }) => (checked ? "#007bff" : "#F5F5F5")};
    border: none;
  }
`;
